/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";
import PaginationResponse from "./PaginationResponse";
import Error from "./Error";
import PaginationRequestSearch from "./PaginationRequestSearch";

export default {
    index(requestSearch: PaginationRequestSearch): Promise<PaginationResponse<Error>> {
        return contentOnly(Axios.post("/error/index", requestSearch, defaultConfig));
    }
}
